import { render, staticRenderFns } from "./auth-login.vue?vue&type=template&id=0cffa7a5&scoped=true&"
import script from "./auth-login.vue?vue&type=script&lang=js&"
export * from "./auth-login.vue?vue&type=script&lang=js&"
import style0 from "./auth-login.vue?vue&type=style&index=0&id=0cffa7a5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffa7a5",
  null
  
)

export default component.exports